import { handleActions } from 'redux-actions';
import { bypassSelector } from './actions';

const defaultState = {};

export default handleActions({
  [bypassSelector]: state => ({ ...state, showSelector: false })
}, defaultState);
